function AddButton({
  handleShow,
  objects,
  animationClass,
  floatingButtonStyle,
}) {
  console.warn("objects", objects);
  return (
    <>
      <button
        onClick={handleShow}
        className={`fade-in ${animationClass}`}
        style={{
          ...floatingButtonStyle,
          opacity: !objects?.exit_interview ? 0.6 : 1,
          cursor: !objects?.exit_interview ? "not-allowed" : "pointer",
        }}
        onMouseOver={(e) => {
          if (objects?.exit_interview) {
            e.currentTarget.style.transform = "scale(1.1)";
          }
        }}
        onMouseOut={(e) => {
          if (objects?.exit_interview) {
            e.currentTarget.style.transform = "scale(1)";
          }
        }}
        disabled={!objects?.exit_interview}
        {...(!objects?.exit_interview && {
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
          "data-bs-title":
            'Please fill out the Exit Interview Form first by clicking the "Exit Interview Form" button at the top right',
        })}
      >
        <i className="bi bi-plus fs-3"></i>
      </button>
    </>
  );
}

export default AddButton;
